var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUp = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "48px",
  height: "48px",
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "icons/ green / arrow-pointing-to-up") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icons/-green-/-arrow-pointing-to-up",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow-pointing-to-right-(2)",
  transform: "translate(15.000000, 12.000000)",
  fill: "#02339c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.6731199,11.6057758 L13.5311263,4.33280653 C13.0953754,3.88906449 12.3886751,3.88906449 11.9529242,4.33280653 C11.5170841,4.77663948 11.5170841,5.49611797 11.9529242,5.93995092 L17.1898803,11.2729466 L-1.8840635,11.2729466 C-2.50032827,11.2729466 -3,11.7817817 -3,12.409348 C-3,13.0368235 -2.50032827,13.5457495 -1.8840635,13.5457495 L17.1898803,13.5457495 L11.9531028,18.8787451 C11.5172626,19.3225781 11.5172626,20.0420566 11.9531028,20.4858895 C12.1709336,20.7076242 12.4566133,20.8187188 12.7422038,20.8187188 C13.0277943,20.8187188 13.3133847,20.7076242 13.5313048,20.4858895 L20.6731199,13.2129202 C21.10896,12.7690873 21.10896,12.0496088 20.6731199,11.6057758 Z",
  id: "Path",
  transform: "translate(9.000000, 12.409359) scale(-1, 1) rotate(-90.000000) translate(-9.000000, -12.409359) "
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-up.86ddf83b0dcf0638604b94929036559e.svg";